// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse.discriminator = undefined;
AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse.additionalProperties = false;
AuthenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserCreateAnyPortalHubUserCreateAnyPortalHubUserResponse.js.map